var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocDataCenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1592_56837)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7637 0C29.1615 0 36.7787 3.56771 36.7787 7.96224C36.7787 12.36 29.1582 15.9245 19.7637 15.9245C10.3691 15.9245 2.7487 12.3568 2.7487 7.96224C2.7487 3.56771 10.3691 0 19.7637 0ZM2.7487 26.6374V32.7507C5.77604 43.5026 35.6849 41.4258 36.7819 32.2005V26.0938C35.2878 36.2207 5.14128 36.9499 2.7487 26.6374ZM2.66406 10.7227V16.6927C5.69141 27.194 35.7663 25.7747 36.8665 16.7676V10.8008C35.3691 20.6934 5.05664 20.7943 2.66406 10.7227ZM2.66406 18.4375V24.5508C5.69141 35.3027 35.7663 33.8509 36.8665 24.6257V18.5189C35.3691 28.6458 5.05664 28.75 2.66406 18.4375Z",
    fill: "#6D77A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1592_56837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocDataCenters);
export default __webpack_public_path__ + "static/media/SOCDataCenters.586a6a53b6d56a5b8493b69c9728f651.svg";
export { ForwardRef as ReactComponent };